import { postOperator } from '../api/postOperator';

export const setPostOperator = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await postOperator(params);

            alert('Сохранено')
          
        } catch(error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}